import { ExtFile, FileInputButton } from "@files-ui/react";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { SetStateAction } from "react";
import { useDebouncedCallback } from "use-debounce";
import { ReactComponent as FilesIcon } from "../../../assets/icons/document.svg";
import { ReactComponent as PdfIcon } from "../../../assets/icons/pdf-icon.svg";
import { ReactComponent as UploadIcon } from "../../../assets/icons/upload-2.svg";
import { DEF_VALID_FILE } from "../../atoms/dashboards/DashboardFileUploader";

const useStyles = makeStyles((theme) => ({
    icon: {
        width: 20,
        height: 20,
		fill: '#0d9488',
    },
    icon2: {
        width: 20,
        height: 20,
		stroke: '#0d9488',
    },
    inputField: {
        width: '100%',
        margin: 0,
        "& .MuiOutlinedInput-root": {
            minWidth: 250,
            padding: '0 8px 0 12px !important',
            height: 45,
            borderRadius: 8,
            background: '#fff',
            "& > input": {
                fontSize: 16,
            },
            "& fieldset": {
              borderColor: 'darkgray !important',
            },
            "&:hover fieldset": {
              borderColor: 'black !important',
            },
            "&.Mui-focused fieldset": {
              borderColor: '#0d9488 !important',
            },
        },
    },
    browseButton: {
		minWidth: '40px',
		minHeight: '40px',
		padding: 'unset !important',
        borderRadius: '50%',
        background: 'transparent !important',
		boxShadow: 'unset !important',
    },
    attachedItem: {
        padding: '4px 8px',
        borderRadius: 12,
    },
    attachmentIcon: {
        height: 24,
        width: 24,
    },
    actionIcon: {
        height: '32px !important',
        width: '32px !important',
        padding: '0 4px !important',
    },
    attachmentName: {
        display: '-webkit-box',
        overflow: 'hidden',
        fontFamily: 'Inter !important',
        fontSize: '0.8rem !important',
        fontWeight: 'bold !important',
        color: '#666666',
        textOverflow: 'ellipsis',
        textTransform: 'none !important' as any,
        textAlign: 'left',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '1',
    },
}));

const DashboardDeckInput: React.FC<{
	deckLink: string,
    extFiles: Array<ExtFile>,
    onUpdate?: (extFiles: ExtFile[]) => void,
  	onDeckLink?: React.Dispatch<SetStateAction<string>>,
}> = ({ deckLink, extFiles, onUpdate, onDeckLink })=> {
    const classes = useStyles();
    const debounced = useDebouncedCallback(value => onDeckLink?.(value.trim()), 30, { maxWait: 100 });

    return (<>
        {!!extFiles.length ? (<>
            <Stack direction="row" spacing={1} className={classes.attachedItem} alignItems="center" justifyContent="flex-start">
                <Stack direction="row" spacing={1} alignItems="center">
                    <PdfIcon className={classes.attachmentIcon} />
                    <Typography className={classes.attachmentName}>{extFiles[0].name}</Typography>
                </Stack>
                <IconButton className={classes.actionIcon} onClick={() => { onUpdate?.([]); onDeckLink?.(''); }}>
                    <CloseIcon />
                </IconButton>
            </Stack>
        </>) : (<>
            <TextField variant="outlined"
                className={classes.inputField}
                placeholder="PDF or DocSend link... (optional)"
                value={deckLink}
                onChange={(e) => debounced(e.target.value as string)}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <FilesIcon className={classes.icon} />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <FileInputButton className={classes.browseButton}
                            onChange={onUpdate}
                            value={extFiles}
                            maxFiles={1}
                            maxFileSize={DEF_VALID_FILE.maxFileSize}
                            accept={DEF_VALID_FILE.allowedFileTypes.join(',')}
                            behaviour="replace"
                            disabled={!!deckLink}>
                            <UploadIcon className={classes.icon2} />
                        </FileInputButton>
                    </InputAdornment>
                ),
                }}
            />
        </>)}
    </>);
}

export default DashboardDeckInput;